import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownContainer, {
  DropdownContainerHeader
} from "../../../../../components/dropdown/DropdownContainer";
import GridExportScopeOptions from "../../../../../components/gridexportmenu/GridExportScopeOptions";
import useExportScope from "../../../../../components/gridexportmenu/hooks/useExportScope";
import { exportScopeValues } from "../../../../../components/gridexportmenu/const";
import api from "../../../api";
import { IOC_TYPES_MAP } from "../consts";
import { IOC, IOCExportProps } from "../../../@types/actor";

const ActorIOCExportDropdown = ({
  pageData,
  selectedRows,
  actorName
}: IOCExportProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const hasSelectedRows = Object.keys(selectedRows).length > 0;
  const { exportScope, setExportScope } = useExportScope(hasSelectedRows);

  const getExportData = (): Array<{ type: string; value: string }> => {
    const selectedSamplesActive =
      hasSelectedRows && exportScope === exportScopeValues.SELECTED;

    const items = selectedSamplesActive
      ? (Object.values(selectedRows) as IOC[])
      : pageData;

    return items.map(item => ({
      type: IOC_TYPES_MAP[item.type as keyof typeof IOC_TYPES_MAP] ?? item.type,
      value: item.value
    }));
  };

  const handleExport = (format: string) => {
    const data = getExportData();
    api.exportActorIOC({ format, data, actorName: actorName || "actor" });
    setShowMenu(false);
  };

  return (
    <DropdownContainer
      name="actor-ioc-export"
      autoClose="outside"
      buttonLabel="Export"
      buttonIcon="export-data"
      show={showMenu}
      onToggle={() => setShowMenu(!showMenu)}
    >
      <>
        <DropdownContainerHeader>
          <GridExportScopeOptions
            useScope
            showScopeNote={false}
            selectedScope={exportScope}
            setSelectedScope={setExportScope}
            hasSelectedRows={hasSelectedRows}
            scopeLabels={{
              page: "Whole page",
              selected: "Selected IOCs"
            }}
          />
        </DropdownContainerHeader>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={() => handleExport("csv")}
          data-testid="actor_ioc_export_csv"
        >
          Export CSV
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => handleExport("json")}
          data-testid="actor_ioc_export_json"
        >
          Export JSON
        </Dropdown.Item>
      </>
    </DropdownContainer>
  );
};

export default ActorIOCExportDropdown;
